import router from '@/router';
import { i18n } from '@/plugins/lang';
import store from '@/store';
import { NJ_OTP_URL } from '@/utils/variables';

const removeComma = (value) => {
  if (!value) return '';
  value = value.toString();
  return value.replace(/\D/g, '');
};

const addComma = (value) => {
  value = removeComma(value);
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',') || '0';
};

const openModal = (data) => {
  store.dispatch('modal/openModal', data);
};

export const validateGlobalWithdraw = ({ code, unit, exchangeMinAmount, exchangeMaxAmount }) => {
  const query = router.currentRoute.query;
  switch (code) {
    case 1:
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailableCurrency'),
      });
      break;
    case 3002: // 출금 불가 나이
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailableAge'),
      });
      break;
    case 3004: // 잔액 1 미만일 경우
    case 3006: // 잔액이 출금 가능 금액 보다 낮을 경우
    case 6001: // 존재하지 않는 유저 (포인트 적립되지 않았을 경우, 유저 정보를 저장하지 않으므로)
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailableEnoughPoint'),
      });
      break;
    case 3010: // 신청 불가 유저
      openModal({
        type: 'alert',
        message: i18n.t('global.validation.notAvailableApplication'),
      });
      break;
    case 3011: // 입력포인트가 보유포인트보다 클 경우
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailableEnoughPoint'),
      });
      break;
    case 3013: // 화폐 최소 금액 이하일 때
      openModal({
        type: 'alert',
        message: i18n.t('global.validation.minWithdrawPoint', {
          minValue: addComma(exchangeMinAmount),
          unit,
        }),
      });
      break;
    case 3014: // 화폐 최대 금액 이하일 때
      openModal({
        type: 'alert',
        message: i18n.t('global.validation.maxWithdrawPoint', {
          maxValue: addComma(exchangeMaxAmount),
          unit,
        }),
      });
      break;
    case 3015: // 글로벌 출금 신청 기간이 아닌 경우
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailablePeriod'),
      });
      break;
    case 8000: // 이메일 미인증 계정
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailableEmail'),
      });
      break;
    case 3005: // RP Core 출금 횟수 초과
    case 80014: // 출금횟수 초과 ssonda
      openModal({
        type: 'alert',
        message: i18n.t('global.notAvailableWithdrawCount'),
      });
      break;
    // JPPC 계정 에러 코드
    case 10001: // NJ 본인확인 미등록
      openModal({
        type: 'confirm',
        message: i18n.t('global.notRegisteredAuth'),
        callback: () => {
          router.push({ name: 'AuthView', query });
        },
      });
      break;
    case 10002: // NJ 본인확인 정보 반려
      openModal({
        type: 'confirm',
        message: i18n.t('global.rejectedAuth'),
        callback: () => {
          router.push({ name: 'AuthView', query });
        },
      });
      break;
    case 10003: // NJ 본인확인 상태 재신청 요청
      openModal({
        type: 'alert',
        message: i18n.t('global.reApplicationAuth'),
        callback: () => {
          router.push({ name: 'AuthView', query });
        },
      });
      break;
    case 10004: // NJ 본인확인 상태 검토중
      openModal({
        type: 'alert',
        message: i18n.t('global.confirmingAuth'),
      });
      break;
    case 10006: // NJ OTP 미등록
      openModal({
        type: 'confirm',
        message: i18n.t('global.noneOtp'),
        callback: () => {
          window.open(NJ_OTP_URL, '_blank');
        },
      });
      break;
    default:
      openModal({
        type: 'alert',
        message: i18n.t('global.validation.commonError'),
      });
      break;
  }
};
